import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import { UNKNOWN } from "../../Constants/locations";
import { getThematicParams } from "../../Helpers/trackingHelper";
var css = {
  "contentWithCTA": "oalp-1KKwd",
  "contentContainer": "oalp-3YDt6",
  "clamped_4": "oalp-PlHsC",
  "clamped_5": "oalp-2LelH",
  "clamped_3": "oalp-18UEZ",
  "cta": "oalp-2yuL1"
};
import UserSession from "../../Utils/UserSession";
import { compose } from 'redux';
import { withRouter } from "../../Helpers/withRouter";
import { withComponentDependency } from "../../ComponentDependency/withComponentDependency";
import ReactMarkdown from 'react-markdown';
import CTA from "../../Components/CTA/CTA";
import withConfig from "./../../ComponentDependency/withConfig";
import cx from 'classnames';
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
var defaultStyle = {};
export var MarkdownContentWithCTA = function MarkdownContentWithCTA(_ref) {
  var name = _ref.name,
    _ref$data = _ref.data,
    image = _ref$data.image,
    content = _ref$data.content,
    cta = _ref$data.cta,
    _ref$data$contentStyl = _ref$data.contentStyle,
    contentStyle = _ref$data$contentStyl === void 0 ? {} : _ref$data$contentStyl,
    metadata = _ref.metadata,
    ReactObserver = _ref.ReactObserver,
    track = _ref.track,
    browsingMode = _ref.browsingMode,
    locationId = _ref.locationId,
    origin = _ref.origin,
    params = _ref.params,
    config = _ref.config;
  var _a;
  var _ref2 = metadata || {},
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? defaultStyle : _ref2$style;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isClamped = _useState2[0],
    setClamped = _useState2[1];
  var contentElm = useRef(null);
  var handleChange = useCallback(function (inView) {
    if (inView && track && metadata && metadata.trackingInfo && metadata.trackingInfo.impressionEvent && metadata.trackingInfo.impressionEvent.name) {
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin
      });
      track(metadata.trackingInfo.impressionEvent.name, Object.assign(Object.assign({}, trackingInfo), getThematicParams(params, config.get())));
    }
  }, [browsingMode, locationId, origin, track, metadata, config, params]);
  var isTextClamped = function isTextClamped(elm) {
    return elm && elm.scrollHeight > elm.clientHeight;
  };
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isClampable = _useState4[0],
    setIsClampable = _useState4[1];
  var handleClamp = useCallback(function () {
    setClamped(!isClamped);
  }, [isClamped]);
  useEffect(function () {
    if (contentElm.current && (content === null || content === void 0 ? void 0 : content.clampable)) {
      setIsClampable(isTextClamped(contentElm.current));
    }
  }, [content, contentElm]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, ReactObserver && /*#__PURE__*/React.createElement(ReactObserver, {
    as: 'div',
    onChange: handleChange,
    "data-aut-id": "observer"
  }), /*#__PURE__*/React.createElement("div", {
    className: css.contentWithCTA,
    style: style
  }, image && /*#__PURE__*/React.createElement(ImageWrapper, {
    image: image
  }), /*#__PURE__*/React.createElement("div", {
    style: contentStyle
  }, /*#__PURE__*/React.createElement("div", {
    ref: contentElm,
    className: cx(css.contentContainer, _defineProperty({}, css["clamped_".concat(content.lines)], isClamped))
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    linkTarget: "_blank"
  }, (_a = content === null || content === void 0 ? void 0 : content.markdownContent) !== null && _a !== void 0 ? _a : '')), isClampable && isClamped && cta && cta.buttons && cta.buttons.map(function (btn, idx) {
    return /*#__PURE__*/React.createElement(CTA, {
      key: idx,
      widgetKey: name,
      handleOnClick: handleClamp,
      button: Object.assign({}, btn),
      track: track,
      metadata: metadata,
      select_from: UserSession.getTabName(),
      customClass: css.cta
    });
  }))));
};
export default compose(React.memo, withRouter, withComponentDependency, withConfig)(MarkdownContentWithCTA);